"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _atom = require("atom");

var _utils = require("reference-resolvers/utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _q = _interopRequireDefault(require("q"));

var _react = _interopRequireWildcard(require("react"));

var _TeamSelect = _interopRequireDefault(require("ui-addon-teams/components/TeamSelect"));

var _ConnectReferenceResolvers = _interopRequireDefault(require("reference-resolvers/ConnectReferenceResolvers"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var initialState = {
  teams: (0, _immutable.List)(),
  isLoading: true
};

var atomToPromise = function atomToPromise(atom) {
  return new _q.default.Promise(function (resolve, reject) {
    var toPromise = (0, _utils.mapResolve)({
      loading: function loading() {},
      error: function error(value) {
        reject(value.reason);
        (0, _atom.unwatch)(atom, toPromise);
      },
      resolved: function resolved(value) {
        if (value != null) {
          resolve(value);
          (0, _atom.unwatch)(atom, toPromise);
        }
      }
    });
    (0, _atom.watch)(atom, toPromise);
    toPromise((0, _atom.deref)(atom));
  });
};

var TimelineFilterTeams =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TimelineFilterTeams, _Component);

  function TimelineFilterTeams(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineFilterTeams);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineFilterTeams).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = initialState;
    _this.renderButtonContent = _this.renderButtonContent.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TimelineFilterTeams, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadTeams();
    }
  }, {
    key: "loadTeams",
    value: function loadTeams() {
      var _this2 = this;

      var promise = atomToPromise(this.props.resolvers.HIERARCHICAL_TEAM.all());
      promise.then(function (resp) {
        _this2.setState({
          teams: resp.toList(),
          isLoading: false
        });
      });
    }
  }, {
    key: "renderButtonContent",
    value: function renderButtonContent() {
      var value = this.props.value;

      if (!value || !value.size) {
        return _react.default.createElement(_FormattedMessage.default, {
          message: "profileContentTimeline.filters.teams.noneSelected"
        });
      }

      return _react.default.createElement(_FormattedMessage.default, {
        message: "profileContentTimeline.filters.teams.selected",
        options: {
          count: value.size
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          teams = _this$state.teams,
          isLoading = _this$state.isLoading;

      if (!isLoading && !teams.size) {
        return null;
      }

      return _react.default.createElement("div", {
        "data-selenium-test": "timeline-filter-teams"
      }, _react.default.createElement(_TeamSelect.default, {
        isLoading: isLoading,
        placeholder: _react.default.createElement(_FormattedMessage.default, {
          message: "profileContentTimeline.filters.teams.noneSelected"
        }),
        showTags: false,
        teams: teams,
        onChange: this.props.onChange,
        value: this.props.value,
        ButtonContent: this.renderButtonContent,
        minimumSearchCount: 0,
        open: this.props.isTeamFilterOpen,
        onOpenChange: this.props.handleTeamOpenChange
      }));
    }
  }]);
  return TimelineFilterTeams;
}(_react.Component);

var getResolvers = (0, _ConnectReferenceResolvers.default)(function (resolvers) {
  return {
    resolvers: resolvers
  };
});
TimelineFilterTeams.propTypes = {
  handleTeamOpenChange: _propTypes.default.func.isRequired,
  isTeamFilterOpen: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  resolvers: _propTypes.default.object,
  value: _propTypes.default.instanceOf(_immutable.List)
};

var _default = getResolvers(TimelineFilterTeams);

exports.default = _default;
module.exports = exports.default;